import { useSelector } from "react-redux";
import logo from "../assets/logo.png";

export default function NavBar({ setToggle }) {
  const counterState = useSelector((state) => state);

  const totalCart = counterState.reduce(
    (prevTotal, state) => state.totalOrder + prevTotal,
    0
  );

  return (
    <div>
      <nav className="bg-[#171C2A] py-4">
        <div className="navBar">
          <a href="index.html">
            <img src={logo} alt="LWS" className="max-w-[140px]" />
          </a>

          <div className="flex gap-4">
            <button
              className="navHome"
              id="lws-home"
              onClick={() => setToggle(0)}
            >
              Home
            </button>
            <button
              className="navCart"
              id="lws-cart"
              onClick={() => setToggle(1)}
            >
              <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
              <span id="lws-totalCart"> {totalCart} </span>
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}
